import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { getIntl, getLocale } from '@umijs/max';
import { message, notification } from 'antd';
import { getToken } from './utils/token';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

// 错误处理方案： 错误类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}
// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      const { success, data, errorCode, errorMessage, showType } =
        res as unknown as ResponseStructure;
      if (!success) {
        const error: any = new Error(errorMessage);
        error.name = 'BizError';
        error.info = { errorCode, errorMessage, showType, data };
        throw error; // 抛出自制的错误
      }
    },
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      const { response } = error;

      const intl = getIntl(getLocale());
      const msgDesc = intl.formatMessage({
        id: 'component.message.networkUnavailable',
        defaultMessage: 'Mạng của bạn không bình thường và không thể kết nối với máy chủ',
      });
      const msg = intl.formatMessage({
        id: 'component.message.networkAbnormal',
        defaultMessage: 'Mạng bất thường',
      });
      if (!response) {
        notification.error({
          description: msgDesc,
          message: msg,
        });
      }
      throw error;
    },
  },

  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      // 拦截请求配置，进行个性化处理。
      try {
        const authData = getToken();

        const token = authData?.accessToken || undefined;

        const authHeader = { Authorization: `Bearer ${token}` };
        let timeZone: string;
        try {
          timeZone = dayjs.tz?.guess() || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
        } catch (e) {
          timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
        }

        if (!token || token === '') {
          return {
            ...config,
            headers: {
              'Content-Type': 'application/json',
              tz: timeZone,
              ...config.headers,
            },
          };
        }

        const configAxios = {
          ...config,
          headers: {
            'Content-Type': 'application/json',
            tz: timeZone,
            ...config.headers,
            ...authHeader,
          },
        };
        return configAxios;
      } catch (e) {
        console.error(e);
      }
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      const { data } = response as unknown as ResponseStructure;

      if (data?.success === false) {
        message.error('请求失败！');
      }
      return response;
    },
  ],
};
